export default {"src":"/_next/static/media/withdraw.1c331f55.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};